export const c_progress_stepper_m_center__step_main_TextAlign = {
  "name": "--pf-c-progress-stepper--m-center__step-main--TextAlign",
  "value": "center",
  "var": "var(--pf-c-progress-stepper--m-center__step-main--TextAlign)"
};
export default c_progress_stepper_m_center__step_main_TextAlign;